export default __webpack_public_path__ + "static/media/add-project-icon.cbcc1817.svg";